import { render, staticRenderFns } from "./NewsBoardPdfPreview.vue?vue&type=template&id=5273bd49&"
import script from "./NewsBoardPdfPreview.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardPdfPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports